var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoRecorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 6.71218C23 6.06309 23 5.73855 22.8742 5.58827C22.7651 5.45787 22.6013 5.38867 22.4338 5.40212C22.2407 5.41763 22.0158 5.64712 21.566 6.10609L17.75 10L21.566 13.8939C22.0158 14.3529 22.2407 14.5824 22.4338 14.5979C22.6013 14.6113 22.7651 14.5421 22.8742 14.4117C23 14.2614 23 13.9369 23 13.2878V6.71218Z",
    stroke: "#437AF8",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.64286C2 5.84269 2 4.9426 2.34333 4.25503C2.64533 3.65022 3.12722 3.1585 3.71993 2.85034C4.39375 2.5 5.27583 2.5 7.04 2.5H12.71C14.4742 2.5 15.3562 2.5 16.0301 2.85034C16.6228 3.1585 17.1047 3.65022 17.4067 4.25503C17.75 4.9426 17.75 5.84269 17.75 7.64286V12.3571C17.75 14.1573 17.75 15.0574 17.4067 15.745C17.1047 16.3498 16.6228 16.8415 16.0301 17.1497C15.3562 17.5 14.4742 17.5 12.71 17.5H7.04C5.27583 17.5 4.39375 17.5 3.71993 17.1497C3.12722 16.8415 2.64533 16.3498 2.34333 15.745C2 15.0574 2 14.1573 2 12.3571V7.64286Z",
    stroke: "#437AF8",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoRecorder);
export default __webpack_public_path__ + "static/media/video-recorder.67ecac6d9285739569272739434d34cb.svg";
export { ForwardRef as ReactComponent };